module.exports = __webpack_public_path__ + "img/editt.ceb42b3b.svg";